import { Col, Row } from '@geberit/gdds';
import key from 'weak-key';

// styles
import styles from './media-tiles.module.scss';

// types
import type { MediaTilesProps } from '../types/press-portal.types';
import type { Media } from '../types/mynewsdesk.types';

// components
import { MediaTile } from './media-tile';

// utils
import { useIsMobile } from 'components/App/SizeProvider';
import { getMaterialUniqueIdentifier } from '../utils';

function MediaTiles({
  mediaList,
  fallbackImg,
  fallbackBackgroundColor,
}: Readonly<MediaTilesProps>) {
  const isMobile = useIsMobile();

  return (
    <Row>
      <Col>
        <div className={styles.mediaTilesWrapper}>
          {mediaList.map((media: Media) => (
            <MediaTile
              path={`?page=asset-detailpage&title=${getMaterialUniqueIdentifier(media as Media)}`}
              key={key(media)}
              isMobile={isMobile}
              media={media}
              fallbackImg={fallbackImg}
              fallbackBackgroundColor={fallbackBackgroundColor}
            />
          ))}
        </div>
      </Col>
    </Row>
  );
}

export default MediaTiles;
